import React from 'react';
import styled from 'styled-components';
import { toast, ToastContainer, ToastContainerProps } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//
import colors from 'theme/colors';

const { error, onyx, yellow, success, white } = colors;

const Container = ({ className }: ToastContainerProps & { className?: string }) => (
  <div className={className}>
    <ToastContainer position={toast.POSITION.BOTTOM_CENTER} autoClose={false} />
  </div>
);

export default styled(Container).attrs({})`
  .Toastify__toast-container {
    width: 580px;
    margin-left: -295px;
  }

  .Toastify__toast {
    background-color: ${onyx};
    color: ${white};
    padding-left: 16px;
    border-radius: 2px;
    margin-bottom: 0;
  }

  .Toastify__toast-body {
    white-space: pre-wrap;
  }

  .Toastify__toast--success {
    border-left: 7px solid ${success};
  }

  .Toastify__toast--warning {
    border-left: 7px solid ${yellow};
  }

  .Toastify__toast--error {
    border-left: 7px solid ${error};
  }

  .Toastify__close-button--default {
    color: ${white};
  }
`;
